import { getInstance as getAuth0ServiceInstance } from '@/auth/index'
import BrowserEnvironmentResolver from './environment.helper'
import { getCartoMeInfo } from './carto.helper'
import { getPresetCountriesForUser } from './country.helper'
import { getAppMetadata } from '@/plan/metadata/metadata'
import UserPermissionManager from './permissions/permissions.manager'
import { getRole } from './auth.helper'
import { Auth } from '@workspaces/types'
import { getRoleForUser } from './testing/auth.helper'
import {
  CacheManager,
  getRoleFromFirebaseToken,
  AuthManager,
} from '@workspaces/services'

export async function initializeUserPermissionManager(): Promise<void> {
  console.debug('👩🏻‍🦰 AuthService: Initializing user permission manager')
  const environmentResolver = BrowserEnvironmentResolver.getInstance()
  const metadata = getAppMetadata()
  const auth0ServiceInstance = getAuth0ServiceInstance()
  let userName: string = Auth.Role.Anonymous
  let userRole = Auth.Role.Anonymous
  let countryIds = []
  if (!auth0ServiceInstance) {
    console.debug(
      '👩🏻‍🦰 AuthService: User not authenticated. Suppose we are in shared plan',
    )
  } else {
    // getUser() returns the authenticated user name; always a string here
    userName = auth0ServiceInstance.getUser() as string

    if (environmentResolver.isTesting()) {
      console.debug('👩🏻‍🦰 🕵️‍♂️ Initialazing permission manager in testing mode')
      countryIds = [1, 6, 9]
      try {
        console.debug('👩🏻‍🦰 🕵️‍♂️ Getting role from Firebase token')
        userRole = await getRoleFromFirebaseToken(
          metadata,
          environmentResolver,
          auth0ServiceInstance.getAccessTokenCartoV3() as string,
        )
      } catch (error) {
        console.warn(
          '👩🏻‍🦰 🕵️‍♂️ Could not retreive role from Firebase token. Trying legacy mode',
        )
        userRole = getRoleForUser(userName)
      }
    } else {
      const cartoMe = await getCartoMeInfo(
        environmentResolver,
        // token is defined here; the undefined path redirects to /login
        auth0ServiceInstance.getAccessTokenCartoV3() as string,
      )

      countryIds = await getPresetCountriesForUser(
        getAppMetadata(),
        environmentResolver,
        cartoMe,
      )

      try {
        userRole = await getRoleFromFirebaseToken(
          metadata,
          environmentResolver,
          auth0ServiceInstance.getAccessTokenCartoV3() as string,
        )
      } catch (error) {
        console.warn(
          '👩🏻‍🦰 Could not retreive role from Firebase token. Trying legacy mode',
        )
        userRole = getRole(metadata, cartoMe)
      }
    }

    auth0ServiceInstance.setRole(userRole)
    console.debug(`👩🏻‍🦰 AuthService - User:  ${userName}`)
    console.debug(`👩🏻‍🦰 AuthService - Role:  ${userRole}`)
    auth0ServiceInstance.setUserCountries(countryIds)
    console.debug('👩🏻‍🦰 AuthService - User countries: ', countryIds)
  }

  UserPermissionManager.initialize({
    name: userName,
    role: userRole,
    agency: null,
  })

  if (!environmentResolver.isSharePlan()) {
    console.debug('👩🏻‍🦰 AuthService - Initializing cache manager')
    CacheManager.getInstance().init(
      environmentResolver,
      // The auth0 wrapper duck-types the AuthManager surface CacheManager uses
      // (unchanged runtime behaviour; the mismatch only became visible once the
      // @workspaces/services types started resolving).
      auth0ServiceInstance as unknown as AuthManager,
      metadata,
    )
  }
}
